
import React from 'react';
import { useListingForm } from '@/context/ListingFormContext';
import { Input } from '@/components/ui/input';
import { FormGroup, FormLabel, FormError, FormHelperText } from '@/components/ui/form-components';
import { Checkbox } from '@/components/ui/checkbox';

const ListingPriceSection = () => {
  const { formData, errors, handleInputChange } = useListingForm();
  
  // Check if the selected category is "Punë & Karrierë" (job & career)
  const isJobCategory = formData.category === '9';
  
  // Check if the category is a service category (IDs 8, 9, 10)
  const isServiceCategory = ['8', '9', '10'].includes(formData.category);
  
  return (
    <div className="space-y-4 mb-8">
      <h2 className="text-lg font-semibold dark:text-white">Informacioni i çmimit</h2>
      
      <FormGroup>
        {/* Conditionally change the label based on category */}
        <FormLabel required>
          {isJobCategory ? 'Paga' : 'Çmimi'}
        </FormLabel>
        <div className="relative">
          <Input
            name="price"
            type="number"
            value={formData.price}
            onChange={(e) => handleInputChange('price', e.target.value)}
            placeholder="0.00"
            className={`pl-8 ${errors.price ? 'border-red-500' : ''}`}
            min="0"
            step="0.01"
          />
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <span className="text-gray-500">€</span>
          </div>
        </div>
        {errors.price && <FormError>{errors.price}</FormError>}
      </FormGroup>
      
      {/* Price negotiable checkbox */}
      <FormGroup>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="is-price-negotiable"
            checked={formData.isPriceNegotiable === 'true'} 
            onCheckedChange={(checked) => {
              handleInputChange('isPriceNegotiable', checked ? 'true' : 'false');
            }}
          />
          <label 
            htmlFor="is-price-negotiable" 
            className="text-sm font-medium leading-none cursor-pointer"
          >
            Çmim i negociueshëm
          </label>
        </div>
        <FormHelperText>
          Zgjidhni këtë opsion nëse çmimi është i hapur për negocim
        </FormHelperText>
      </FormGroup>
      
      {/* Only show stock field if NOT a service category (not just job) */}
      {!isServiceCategory && (
        <FormGroup>
          <FormLabel required>Sasia në stok</FormLabel>
          <Input
            name="stock"
            type="number"
            value={formData.stock}
            onChange={(e) => handleInputChange('stock', e.target.value)}
            placeholder="1"
            className={errors.stock ? 'border-red-500' : ''}
            min="1"
          />
          {errors.stock && <FormError>{errors.stock}</FormError>}
        </FormGroup>
      )}
    </div>
  );
};

export default ListingPriceSection;
